import { useCallback, useEffect, useRef, useState } from 'react';
import { getSessionToken, getUserDetails } from '../Services/services';
import { request } from '../api/httpClient';

export function patchPersonalizations(patch) {
  return request({ method: 'PATCH', url: '/user/personalizations', data: patch });
}

export function usePersonalizations() {
  const [prefs, setPrefs] = useState({});
  const [ready, setReady] = useState(false);
  const writeChain = useRef(Promise.resolve());
  const pendingPatch = useRef({});
  const dirty = useRef(false);

  useEffect(() => {
    if (!getSessionToken()) {
      setReady(true);
      return;
    }
    getUserDetails()
      .then((resp) => {
        // Do not clobber Expand all / Collapse all that already happened locally.
        if (dirty.current) return;
        setPrefs(resp?.data?.personalizations || {});
      })
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  const setPref = useCallback((key, value) => {
    dirty.current = true;
    pendingPatch.current[key] = value;
    setPrefs((prev) => ({ ...prev, [key]: value }));
    writeChain.current = writeChain.current
      .catch(() => {})
      .then(async () => {
        const patch = pendingPatch.current;
        pendingPatch.current = {};
        if (Object.keys(patch).length === 0) return;
        try {
          await patchPersonalizations(patch);
        } catch {
          // Keep optimistic UI; next GET /user/details will reconcile.
        }
      });
  }, []);

  return { prefs, ready, setPref };
}
